import { render, staticRenderFns } from "./jobcontent.vue?vue&type=template&id=27b607d5"
import script from "./jobcontent.vue?vue&type=script&lang=js"
export * from "./jobcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports